import { createIcon } from '@chakra-ui/react';

export const BurgerMenuIcon = createIcon({
  displayName: `BurgerMenuIcon`,
  viewBox: `0 0 22.192 17.244`,
  defaultProps: {
    color: `brand.500`,
  },
  path: (
    <g transform="translate(-1535.309 -437.5)">
      <path
        d="M4.5,18H23.692"
        transform="translate(1532.309 428.122)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
      />
      <path
        d="M4.5,9h7.668"
        transform="translate(1532.309 430)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
      />
      <path
        d="M4.5,27h7.668"
        transform="translate(1543.832 426.244)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
      />
    </g>
  ),
});
